enum EventNames {
  shellTenantSelectorFinished = 'shell-tenant-selector-finished',
  shellCriterionChangedEventName = 'shell-criterion-changed',
  shellEntitlementChangedEventName = 'shell-entitlement-changed',
  shellAccessControlChangedEventName = 'shell-access-control-changed',
  shellUserLoggedOutEventName = 'shell-user-logged-out',
  shellUserLoggedInEventName = 'shell-user-logged-in',
  shellCallInterfaceNavigationPush = 'shell-interface-v1-navigation-push',
  clientosLoggedinFinished = 'clientos-loggedin-finished',
  clientosCallInterfaceNavigationPush = 'clientos-northbound-api-v1-navigation-push',
  clientosCallInterfaceNavigationGoBack = 'clientos-northbound-api-v1-navigation-goBack',
  clientosNavigationBlocked = 'clientos-navigation-blocked',
  shellUrlChanged = 'shell-url-changed',
  shellFeatureFlagChangedEventName = 'shell-feature-flag-changed',
  webOnboardingStarted = 'WebOnboardingStarted',
  webOnboardingStageStarted = 'WebOnboardingStageStarted',
  webOnboardingStageFinished = 'WebOnboardingStageFinished',
  webOnboardingFinished = 'WebOnboardingFinished',
  shellAnalyticsSimpleUiEvent = 'shell-analytics-simpleui-event',
  shellTenantChangedEventName = 'shell-tenant-changed',
  shellTenantListUpdatedEventName = 'shell-tenant-list-updated',
  shellGrantsChangedEventName = 'shell-grants-changed',
  shellGrantsHistoryChangedEventName = 'shell-grants-history-changed',
  shellPendingGrantsChangedEventName = 'shell-pending-grants-changed',
  shellCriterionForceCheckUpdate = 'shell-criterion-force-check-update',
  globalMicrofrontendRouter = 'shell-global-microfrontend-router',
  globalMicrofrontendRouterURL = 'shell-global-microfrontend-router-url',
  globalMicrofrontendRouterOnboarding = 'shell-global-microfrontend-router-onboarding',
  globalFallback = 'shell-fallback'
}

export default EventNames;
